$(document).ready(function(){

	//main slider
		$('.js-slider').slick({
			dots: false,
			speed: 500,
			fade: true,
			autoplay: true,
			autoplaySpeed: 7000
		});


	//offerSlider
	$('.js-offerSlider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: true,
		fade: false,
		asNavFor: '.offerSliderThumbs',
		centerMode: true,
		centerPadding: '12.5%',
		variableWidth: true,
		autoplay: true,
		autoplaySpeed: 70000
	});
	$('.js-offerSliderThumbs').slick({
		slidesToShow: 8,
		slidesToScroll: 1,
		//asNavFor: '.js-offerSlider',
		dots: false,
		//focusOnSelect: true,
		autoplay: true,
		autoplaySpeed: 7000
	});


	// js-up
		$(".js-up").on("click", function () {
				var body = $("html, body");
				body.stop().animate({scrollTop: 0}, 1500, 'swing');
		});

		//language switcher
		$('.language a:first-child').on('click',function(){
			$(this).parent().toggleClass('language--active');
			return false;
		});

		//search
		$('.js-top__tools-search').on('click',function(){
			var input = $('.js-top__tools-search input');
			$(this).toggleClass('top__tools-search--active');
			if(input.is(":focus")) {
				input.blur();
			} else {
				input.focus();
			}
			return false;
		});
		$(".js-top__tools-search input").click(function(e) {
			e.stopPropagation();
	   });

		//scrolled menu
		if ($(window).width()<1240){
				$('.js-top').addClass('top--scrolled');
		} else {
				$('.js-top').removeClass('top--scrolled');
		}
	// relax init
	if ($('.rellax').length) {
		var rellax = new Rellax('.rellax', {
			wrapper: '.rellaxWrapper',
			relativeToWrapper: true
		});
	}
	
	//aos animations
	AOS.init();

	//hero offer button
		$('.js-offerButton').on('click', function(){
			$('html, body').animate({
				scrollTop: $(".offerSlider").offset().top
			}, 1000);
			return false;
		});
	//landing scroll
	// window.addEventListener("wheel", function (event) { event.preventDefault (); }, {passive: true} );
	// window.addEventListener ("touchmove", function (event) { event.preventDefault (); }, {passive: false});
	
	if ( $(window).width() > 1240 && $('.js-landing__wrapper').length) {
		$.scrollify({
			section : ".js-landing__wrapper",
			sectionName: false,
			interstitialSection:".top,.footer,.mobileMenu,.up,.cookiesInfo, .fb_reset"
		});
		$('.js-landing__wrapper:not(:last-child) .js-landing__arrow').on('click', function(){
			$.scrollify.next();
			//var elem = $(this).closest('.js-landing__wrapper').next('.js-landing__wrapper');
		});
		$('.js-landing__wrapper:last-child .js-landing__arrow').on('click', function(){
			$.scrollify.move(1);
		});
	}


  var selectedFiles = [];

  $("#attachments").on('change', function(e) {
    var maxFileSize = 20 * 1024 * 1024;

    for (var i = 0; i < this.files.length; i++) {
      var file = this.files[i];
      var fileSize = file.size;

      if (fileSize > maxFileSize) {
        var alertText = $('<p/>', { text: 'Przekroczono rozmiar pliku', class: 'alert-text' });
        $(".styledForm__row--alert").addClass('active').append(alertText);
        continue;
      }
      else {
        $(".styledForm__row--alert").removeClass('active');
        $(".styledForm__row--alert p").remove();
      }

      selectedFiles.push(file);

      var fileName = $('<span/>', { text: file.name, class: 'filesList__name' });
      var fileBloc = $('<span/>', { class: 'filesList__box' }).append(fileName);
      fileBloc.append('<span class="filesList__delete"></span>');
      $(".styledForm__row > .filesList").append(fileBloc);
    }
  });

  $(document).on('click', '.filesList__delete', function() {
    var index = $(this).parent().index();
    $(this).parent().remove();
    selectedFiles.splice(index, 1);
  });


	

}); //end documentready

$(window).on("scroll", function () {

	//js-up
	var scroll = $(window).scrollTop();
	if (scroll > 600) {
			$(".js-up").addClass("visible");
	} else {
			$(".js-up").removeClass("visible");
	}

	//scrolled menu
	if ($(window).scrollTop() > 0){
		$('.js-top').addClass('top--scrolled');
 	} else {
		if ($(window).width()>1240){
			$('.js-top').removeClass('top--scrolled');
		}
 }

}); //end onscroll

$( window ).load(function() {
	$('.js-slider .slider__text').removeClass('slider__text--hidden');
});

function setTimeCoockie() {
	let backgrCoockie = $('#CybotCookiebotDialog');
	let windowCoockie = $('#CybotCookiebotDialogBodyUnderlay');
	backgrCoockie.attr('style','display:flex!important;');
	windowCoockie.attr('style','display:flex!important;');
}
  
setTimeout(setTimeCoockie, 3000);